// import { useState } from 'react';

// interface AuthResponse {
//     token?: string; // ajuste conforme o que a API retorna
//     [key: string]: any;
// }

// interface ErrorResponse {
//     verified?: boolean; // ajuste conforme o que a API retorna
//     message: string
// }

// export function useAuth() {
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState<ErrorResponse | null>(null);
//     const [data, setData] = useState<AuthResponse | null>(null);

//     const baseUrl = process.env.REACT_APP_BASE_API_URL

//     async function signIn(email: string, password: string) {
//         setLoading(true);
//         setError(null);
//         setData(null);
//         // console.log("Enviando dados para login:", { email, password });

//         try {
//             const response = await fetch(`${baseUrl}/api/auth/sign-in`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ email, password }),
//             });

//             const responseData = await response.json();
//             console.log("Resposta completa do servidor:", {

//                 data: responseData
//             });

//             if (!response.ok) {
//                 setError(responseData);
//                 console.log("Erro detalhado:", responseData);
//                 return null;
//             }

//             setData(responseData);
//             return responseData;
//         } catch (err: any) {
//             console.error("Erro de rede:", err);
//             setError({
//                 message: err.message || 'Connection error. Please try again.'
//             });
//             return null;
//         } finally {
//             setLoading(false);
//         }
//     }

//     return { loading, error, data, signIn };
// }


// import { useState, useRef } from 'react';


// interface AuthResponse {
//     access_token?: string;
//     token?: string;
//     verified?: boolean;
//     [key: string]: any;
// }

// interface ErrorResponse {
//     verified?: boolean;
//     message: string;
// }

// // Hook para gerenciar autenticação globalmente
// export function useAuth() {
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState<ErrorResponse | null>(null);
//     const [data, setData] = useState<AuthResponse | null>(null);

//     // Adicionar referência para evitar múltiplas chamadas
//     const isSubmittingRef = useRef(false);

//     const baseUrl = process.env.REACT_APP_BASE_API_URL;

//     async function signIn(email: string, password: string) {
//         // Verificar se já está fazendo login
//         if (isSubmittingRef.current) {
//             console.log("Login já em andamento, ignorando nova chamada");
//             return null;
//         }

//         isSubmittingRef.current = true;
//         setLoading(true);
//         setError(null);
//         setData(null);

//         try {
//             const response = await fetch(`${baseUrl}/api/auth/sign-in`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({ email, password }),
//             });

//             const responseData = await response.json();
//             console.log("Resposta completa do servidor:", responseData);

//             if (!response.ok) {
//                 setError(responseData);
//                 isSubmittingRef.current = false;
//                 return null;
//             }

//             setData(responseData);

//             const token = responseData.access_token || responseData.token || responseData.jwt;

//             if (token) {
//                 localStorage.setItem('token', token);
//                 window.dispatchEvent(new Event('storage'));
//                 window.dispatchEvent(new CustomEvent('authStateChanged'));
//                 console.log("Token salvo no localStorage:", token);
//             }

//             return responseData;
//         } catch (err: any) {
//             console.error("Erro de rede:", err);
//             setError({
//                 message: err.message || 'Connection error. Please try again.'
//             });
//             return null;
//         } finally {
//             setLoading(false);
//             isSubmittingRef.current = false;
//         }
//     }

//     // Função para logout
//     function logout() {
//         localStorage.removeItem('token');
//         localStorage.removeItem('userEmail');
//         window.dispatchEvent(new Event('storage'));
//         window.dispatchEvent(new CustomEvent('authStateChanged'));
//         setData(null);
//         console.log("Usuário deslogado");
//     }

//     // Função para verificar se está autenticado
//     function isAuthenticated(): boolean {
//         const token = localStorage.getItem('token');
//         return !!token; // Retorna true se existir token
//     }

//     // Função para obter o token atual
//     function getToken(): string | null {
//         return localStorage.getItem('token');
//     }

//     // Função para fazer login programaticamente (útil após registro ou verificação)
//     function loginWithToken(token: string) {
//         localStorage.setItem('token', token);
//         window.dispatchEvent(new Event('storage'));
//         window.dispatchEvent(new CustomEvent('authStateChanged'));
//     }

//     return {
//         loading,
//         error,
//         data,
//         signIn,
//         logout,
//         isAuthenticated,
//         getToken,
//         loginWithToken
//     };
// }






import { useState } from 'react';

interface AuthResponse {
    access_token?: string;
    token?: string;
    verified?: boolean;
    [key: string]: any;
}

interface ErrorResponse {
    verified?: boolean;
    message: string;
}

// Hook apenas para chamadas API de autenticação
export function useAuthAPI() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ErrorResponse | null>(null);
    const [data, setData] = useState<AuthResponse | null>(null);

    const baseUrl = process.env.REACT_APP_BASE_API_URL;

    async function signIn(email: string, password: string) {
        setLoading(true);
        setError(null);
        setData(null);

        try {
            const response = await fetch(`${baseUrl}/api/auth/sign-in`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email, password }),
            });

            const responseData = await response.json();
            console.log("🔍 useAuthAPI - Resposta do servidor:", responseData);

            if (!response.ok) {
                setError(responseData);
                return null;
            }

            setData(responseData);
            return responseData;

        } catch (err: any) {
            console.error("Erro de rede:", err);
            setError({
                message: err.message || 'Connection error. Please try again.'
            });
            return null;
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        data,
        signIn
    };
}